import { Injectable } from '@angular/core';
import { FeatureFlagService } from '@core/feature';
import { CustomProduct } from '@product/const';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

// этот сервис задумывался как компонентный и должен был быть 1 инстанс на 1 продукт
// но не фартануло и он стал рутовый

@Injectable({ providedIn: 'root' })
export class TransitPriceStateService {
  private transitSwitchStateList: Map<string, TransitPriceMode> = new Map();

  constructor(private featureFlagService: FeatureFlagService) {}

  getTransitState(product: CustomProduct): Observable<TransitPriceMode | undefined> {
    if (product.transitPrice === undefined) {
      return of(undefined);
    }

    return this.featureFlagService.isEnabled('transitPriceDefaultSelected').pipe(
      distinctUntilChanged(),
      map((transitPriceDefaultSelected) => {
        const shouldShowTransit = this.calculateShouldShowTransit(product, transitPriceDefaultSelected);

        if (!this.transitSwitchStateList.has(product.code)) {
          this.transitSwitchStateList.set(product.code, new TransitPriceMode(product, shouldShowTransit));
        } else {
          const existingInstance = this.transitSwitchStateList.get(product.code);
          if (existingInstance) {
            existingInstance.setState(shouldShowTransit);
          }
        }

        return this.transitSwitchStateList.get(product.code);
      }),
    );
  }

  private calculateShouldShowTransit(product: CustomProduct, transitPriceDefaultSelected: boolean): boolean {
    // Если товара НЕТ в наличии - всегда показываем транзитную цену
    if (product.stock?.stockLevelStatus === 'outOfStock') {
      return true; // Транзитная цена для outOfStock
    }

    // Для товаров в наличии - смотрим на флаг
    return transitPriceDefaultSelected; // true = транзитная, false = розничная
  }
}

// Вспомогательный класс реализующий транзитное состояние юай продукта
export class TransitPriceMode {
  product: CustomProduct;
  switchState$: BehaviorSubject<boolean>;

  constructor(product: CustomProduct, defaultValue: boolean) {
    this.product = product;
    this.switchState$ = new BehaviorSubject<boolean>(defaultValue);
  }

  toggleState(): void {
    this.switchState$.next(!this.switchState$.value);
  }

  setState(value: boolean): void {
    this.switchState$.next(value);
  }
}
